import React, { Component } from "react";
import {
  getFirestore,
  getDocs,
  collection,
  query,
  where,
} from "firebase/firestore";
import { useParams } from "react-router-dom";
import themeLarge from "../component/ThemeLarge";
import Footer from "../component/Footer";
import RandomBlogView from "../component/blogList/randomBlogs";

/**
 * Components
 */
import BlogTitleView from "../component/blogView/blogTitle";
import BlogContentView from "../component/blogView/blogContent";
import BlogCoverPhotoView from "../component/blogView/blogCover";
import SEO from "../utils/SEO";
import LoadingLottie from "../component/Loading";

class SingleBlogPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobileView: window.innerWidth <= 1100,
      blog: null, // Store the blog data here
      loading: true, // To show loading state
      error: null, // To show any error during fetching,
      createdAt: "Unknown Date",
    };
  }

  async componentDidMount() {
    window.addEventListener("resize", this.updateWindowSize);
    this.fetchBlog();
  }

  // Remove event listener when the component unmounts to avoid memory leaks
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowSize);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.params.slug !== this.props.params.slug) {
      window.scrollTo(0, 0); // 👈 scroll to top immediately
      this.setState({ loading: true }, () => {
        this.fetchBlog();
      });
    }
  }

  async fetchBlog() {
    const { slug } = this.props.params;
    const db = getFirestore();
    const blogsCollection = collection(db, "blogs");
    const q = query(blogsCollection, where("slug", "==", slug));

    try {
      const querySnapshot = await getDocs(q);
      if (!querySnapshot.empty) {
        const blogSnap = querySnapshot.docs[0];
        const data = blogSnap.data();

        const createdAt = data.createdAt
          ? new Date(data.createdAt.seconds * 1000).toLocaleDateString(
              "en-US",
              {
                month: "short",
                day: "2-digit",
                year: "numeric",
              }
            )
          : "Unknown Date";

        this.setState({
          blog: data,
          loading: false,
          createdAt: createdAt,
        });
      } else {
        this.setState({ error: "Blog not found", loading: false });
      }
    } catch (error) {
      this.setState({ error: "Failed to fetch blog data", loading: false });
    }
  }

  calculateReadTime(content) {
    if (!content) return 0;

    const text = content.replace(/<[^>]+>/g, " "); // Remove HTML tags
    const words = text.trim().split(/\s+/).length; // Split by spaces
    const minutes = Math.ceil(words / 200); // 200 words per minute
    return minutes;
  }

  render() {
    const { blog, loading, error, createdAt, isMobileView } = this.state;
    let minutesToRead = 0;
    if (blog) {
      minutesToRead = this.calculateReadTime(blog.content);
    }

    if (loading) {
      return (
        <div className="loading-container">
          <LoadingLottie />
        </div>
      );
    }

    if (error) {
      return (
        <div className="error-container">
          <h3 className="h3 error-message">{error}</h3>
        </div>
      );
    }

    return (
      <div
        style={{
          marginTop: isMobileView ? "0px" : "95px",
        }}
      >
        <SEO
          title={blog.title}
          description={blog.excerpt}
          image={blog.coverPhoto}
          url={`https://ibtehaz.xyz/blogs/${blog.slug}`}
        />

        <BlogTitleView
          title={blog.title}
          subtitle={blog.subtitle}
          minutesToRead={minutesToRead}
          createdAt={createdAt}
        />

        <BlogCoverPhotoView title={blog.title} coverPhoto={blog.coverPhoto} />

        <BlogContentView
          content={blog.content}
          photos={blog.photos}
          tags={blog.tags}
        />

        <div
          style={{
            background: themeLarge.colors.bg,
            paddingTop: isMobileView ? "10px" : "0px",
          }}
        >
          {isMobileView ? (
            <div>
              <RandomBlogView currentSlug={this.props.params.slug} />
            </div>
          ) : (
            <div className="row">
              <div className="col-md-2"></div>
              <div className="col-md-8">
                <RandomBlogView currentSlug={this.props.params.slug} />
              </div>
              <div className="col-md-2"></div>
            </div>
          )}
        </div>

        <Footer />
      </div>
    );
  }
}

// Higher-order component to get `params` (like blogId)
function withRouter(Component) {
  return function Wrapper(props) {
    const params = useParams();
    return <Component {...props} params={params} />;
  };
}

export default withRouter(SingleBlogPage);
